import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UmsService } from '../ums.service';
import { Router } from '@angular/router';
import { Color, Label } from 'ng2-charts';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { element } from 'protractor';
// import {MatTableDataSource, MatSort} from '@angular/material';

export interface Element {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}



const ELEMENT_DATA: Element[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
  {position: 11, name: 'Sodium', weight: 22.9897, symbol: 'Na'},
  {position: 12, name: 'Magnesium', weight: 24.305, symbol: 'Mg'},
  {position: 13, name: 'Aluminum', weight: 26.9815, symbol: 'Al'},
  {position: 14, name: 'Silicon', weight: 28.0855, symbol: 'Si'},
  {position: 15, name: 'Phosphorus', weight: 30.9738, symbol: 'P'},
  {position: 16, name: 'Sulfur', weight: 32.065, symbol: 'S'},
  {position: 17, name: 'Chlorine', weight: 35.453, symbol: 'Cl'},
  {position: 18, name: 'Argon', weight: 39.948, symbol: 'Ar'},
  {position: 19, name: 'Potassium', weight: 39.0983, symbol: 'K'},
  {position: 20, name: 'Calcium', weight: 40.078, symbol: 'Ca'},
];


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  displayedColumns = ['position', 'name', 'weight', 'symbol'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  Showcollege = false
  Showcourse = false
  Showcollege2 = false
  Showcourse2 = false
  ShowTown = false
  ShowDistrict = false
  SelectedData = '';
  //bar chart data
  public barChartOptions: any = {
    // ...chart options
    responsive: true,
    animation: {
      duration: 3000, // Animation duration in milliseconds
      easing: 'easeInOutQuart' // Easing function (optional)
    },
  title: {
    display: true,
    text: 'Total Courses'
  },
 
  };
  public barChartLabels: string[] = [];
 
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
 
  public barChartData: any[] = [
    { data: [], label: 'Permitted Intake' ,backgroundColor: '#c7c7c7', // Grey color for Series A bars
    borderColor: '#c7c7c7',hoverBackgroundColor: '#c7c7c7',hoverBorderColor: '#c7c7c7',
    borderWidth: 1},
    { data: [], label: 'Total Admission',backgroundColor: '#1254f4', // Blue color for Series B bars
    borderColor: '#1254f4',hoverBackgroundColor: '#1254f4',hoverBorderColor: '#1254f4',
    borderWidth: 1 ,pointBorderColor: 'blue', // Border color for the points
    pointHoverBackgroundColor: 'blue', pointBackgroundColor: 'blue',// Hover color for the points
  }
  ];

  public barChartOptions1: ChartOptions = {
    responsive: true,
    animation: {
      duration: 3000, // Animation duration in milliseconds
      easing: 'easeInOutQuart' // Easing function (optional)
    },
    title: {
      display: true,
      text: 'Pass Fail Students Count'
    },
  };
  public barChartLabels1: Label[] = [];
  public barChartType1: ChartType = 'bar';
  public barChartLegend1 = true;
  public barChartPlugins1 = [];

    public barChartData1: ChartDataSets[] = [
      { data: [], label: 'Passed Students', stack: 'a',backgroundColor: '#1254f4', borderColor: '#1254f4',
      hoverBackgroundColor: '#1254f4',hoverBorderColor: '#1254f4',
      borderWidth: 1 ,pointBorderColor: '#1254f4',pointHoverBackgroundColor: '#1254f4', pointBackgroundColor: '#1254f4', },
      { data: [], label: 'Failed Students', stack: 'a',backgroundColor: '#c7c7c7', 
      borderColor: '#c7c7c7',hoverBackgroundColor: '#c7c7c7',hoverBorderColor: '#c7c7c7',
      borderWidth: 1 ,pointBorderColor: '#c7c7c7',pointHoverBackgroundColor: '#c7c7c7', pointBackgroundColor: '#c7c7c7', },
    ];
    public barChartData2: ChartDataSets[] = [
      { data: [], label: 'Paid Fee', stack: 'a',backgroundColor: '#1254f4', borderColor: '#1254f4',
      hoverBackgroundColor: '#1254f4',hoverBorderColor: '#1254f4',
      borderWidth: 1 ,pointBorderColor: '#1254f4',pointHoverBackgroundColor: '#1254f4', pointBackgroundColor: '#1254f4', },
      { data: [], label: 'Outstanding Fee', stack: 'a',backgroundColor: '#c7c7c7', 
      borderColor: '#c7c7c7',hoverBackgroundColor: '#c7c7c7',hoverBorderColor: '#c7c7c7',
      borderWidth: 1 ,pointBorderColor: '#c7c7c7',pointHoverBackgroundColor: '#c7c7c7', pointBackgroundColor: '#c7c7c7', },
    ];
    public barChartType2: ChartType = 'bar';
    public barChartLabels2: string[] = [];
    public barChartOptions2: ChartOptions = {
      responsive: true,
      animation: {
        duration: 3000, // Animation duration in milliseconds
        easing: 'easeInOutQuart' // Easing function (optional)
      },
      title: {
        display: true,
        text: 'Paid and Outstanding Fee'
      },
    };
    public barChartLegend2 = true;
  public barChartOptions3: any = {
    // ...chart options
    responsive: true,
    animation: {
      duration: 3000, // Animation duration in milliseconds
      easing: 'easeInOutQuart' // Easing function (optional)
    },
    scales: {
      x: [{
        ticks: {
          beginAtZero: true,
          stepSize: 1, // Set the step size to 1 to display only integers
        }
      }]
    },
  };
  public barChartData3: any[] = [
    { data: [], label: 'Registered Students Count',backgroundColor: '#1254f4', borderColor: '#1254f4',
    hoverBackgroundColor: '#1254f4',hoverBorderColor: '#1254f4',
    borderWidth: 1 ,pointBorderColor: '#1254f4',pointHoverBackgroundColor: '#1254f4', pointBackgroundColor: '#1254f4',}
  ];
  public barChartLabels3: string[] = [];
  public barChartType3: string = 'bar';
  public barChartLegend3: boolean = true;

  //pie chart
  public pieChartOptions: any = {
    // ...chart options
    responsive: true,
    animation: {
      duration: 3000, // Animation duration in milliseconds
      easing: 'easeInOutQuart' // Easing function (optional)
    },
    legend: {
      position: 'right', // Position the legend on the right side
      align: 'start' // Align the legend text at the start (top) of the legend block
    },
    title: {
      display: true,
      text: 'Caste Wise Data'
    },
  };
  public pieChartData: number[] = [];
  public pieChartLabels: string[] = [];
  public pieChartLegend: boolean = true;
  public piecolors: Color[] = [
    {
      backgroundColor:
      [
        'violet',
        'indigo',
        'blue',
        'green',
        'yellow',
        'orange',
        'red',
        'pink',
        'teal',
      ]
    },
  ]
  //doughnut chart
  public doughnutChartOptions: any = {
    // ...chart options
    responsive: true,
    animation: {
      duration: 3000, // Animation duration in milliseconds
      easing: 'easeInOutQuart' // Easing function (optional)
    },
    title: {
      display: true,
      text: 'Gender Wise Data'
    },
  };
  public doughnutChartData: number[] = [];
  public doughnutChartLabels: string[] = ['Female', 'Male'];
  public doughnutChartType: string = 'doughnut';
  public doughnutColor: Color[] = [
    {
      backgroundColor: [
        '#c7c7c7',
        '#1254f4',
        '#808080',
      ]
    },
 ]
  
  @ViewChild(MatSort) sort: MatSort;
  totalCourses: any;
  totalExams: any;
  totalGrievance: any;
  totalCollege: any;
  totalStu: any;
  collegedataList: any;
  filteredListCollege: any;
  courselist: any;
  filteredListCourse: any;
  DasboardForm: FormGroup;
  SessionNo: any;
  today: Date = new Date();
  cards: any[] = [];
  kpiCards: any[] = [];
  collegeChartData = [    
    { "Course": "BAMS", "TotalFail": 40, "TotalPass": 60, "TotalStudentCount": 100 },     
    { "Course": "BHMS", "TotalFail": 50, "TotalPass": 70, "TotalStudentCount": 120  },    
    { "Course": "BHMS1", "TotalFail": 64, "TotalPass": 88, "TotalStudentCount": 152 },    
    { "Course": "MBBS", "TotalFail": 60, "TotalPass": 28, "TotalStudentCount": 88 }   ];
  
    courseChartData = [    
      { "College": "KLE", "TotalFail": 80, "TotalPass": 30, "TotalStudentCount": 110 },     
      { "College": "DYP", "TotalFail": 60, "TotalPass": 28, "TotalStudentCount": 88  },    
      { "College": "DYPC", "TotalFail": 50, "TotalPass": 70, "TotalStudentCount": 120 },    
      { "College": "BDP", "TotalFail": 64, "TotalPass": 88, "TotalStudentCount": 152 },
      { "College": "CG02", "TotalFail": 90, "TotalPass": 50, "TotalStudentCount": 140 }];
  townlist: any;
  filteredListTown: any;
  districtlist: any;
  filteredListDistrict: any;
  totalCount = 0;
  sessionList: any[];
  SessionFilterList: any[];
  filteredCourseList: any;
  courseList: any;
  totalApplication: any;
  incompleteApplication: any;
  underScrutiny: any;
  approveApplication: any;
  totalPaidApplication: any;
  totalUnpaidApplication: any;
  rejectedApplication: any;
  documentError: any;
  // constructor( private translate: TranslateService
  //   ) {translate.setDefaultLang('en'); }
    constructor(private fb: FormBuilder,public umsService: UmsService, public router: Router,private spinner: NgxSpinnerService,) 
    {}
    // {{'login.title' | translate }}
    utp: any;
    userPermission: any;
    showChart;

//     kpiCards = [
//   {
//     title: 'Total Applications',
//     value: 2540,
//     icon: 'description',
//     color: 'blue'
//   },
//   {
//     title: 'Incomplete Applications',
//     value: 312,
//     icon: 'warning',
//     color: 'orange'
//   },
//   {
//     title: 'Applications Under Scrutiny',
//     value: 188,
//     icon: 'search',
//     color: 'purple'
//   },
//   {
//     title: 'Approved Applications',
//     value: 1230,
//     icon: 'check_circle',
//     color: 'green',
//     change: '+8%',
//     note: 'this week'
//   },
//   {
//     title: 'Total Paid Applications',
//     value: 1632,
//     icon: 'payments',
//     color: 'blue'
//   },
//   {
//     title: 'Rejected Applications',
//     value: 88,
//     icon: 'cancel',
//     color: 'red',
//     change: '-2%',
//     note: 'this week'
//   },
//   // {
//   //   title: 'Total Paid Applications',
//   //   value: 1632,
//   //   icon: 'account_balance_wallet',
//   //   color: 'teal'
//   // },
//   {
//     title: 'Total Unpaid Applications',
//     value: 908,
//     icon: 'money_off',
//     color: 'gray'
//   }
// ];
  ngOnInit(): void {
    // this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    // this.utp = sessionStorage.getItem('usertypeee');
    // if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
    //   this.userPermission.forEach(element => {
    //     if (element.PageName == "Dashboard" && element.PView == false) {
         
    //      this.showChart = false;
    //     }
    //     else{
    //       this.showChart = true;
    //     }

    //   });
    // }
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getUserPermission()
      this.DashBoardCount();
      
      this.StuPerformance('course')
      this.loadgraph('course')
      this.GenderCount()
      this.getDrp('college')
      this.CasteCount()
      this.AdmissionCount()
      this.FeeAmountCount();
      this.get('','College')
      this.getCollegeData();
      
    }
    this.DasboardForm = this.fb.group({
      StuCount: new FormControl ('course'),
      CoClg: new FormControl ('College'),
      Course: new FormControl ('SelectedData'),
      College: new FormControl('SelectedData'),
      Course2: new FormControl ('SelectedData'),
      College2: new FormControl('SelectedData'),
      Town: new FormControl('SelectedData'),
      District: new FormControl('SelectedData'),
      SnNo: new FormControl(''),
      CoCode: new FormControl(''),
      CgCode: new FormControl(''),
      FromDate: new FormControl(''),
      ToDate: new FormControl(''),

    });
    this.Showcollege = true;
    this.Showcourse = false;
    this.Showcollege2 = true;
      this.Showcourse2 = false;
      this.ShowTown = false;
      this.ShowDistrict = false;
    
    this.SelectedData = "All";
    this.fetchSession();
    this.fetchCourseData();
    this.DasboardForm.valueChanges.subscribe(() => {
    this.DashBoardCount();
  });
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.getUserPermission()
      this.DashBoardCount();
      // this.GrievanceCount();
      // this.StudentRequest()
      this.StuPerformance('course')
      this.loadgraph('course')
      this.GenderCount()
      this.getDrp('college')
      this.CasteCount()
      this.AdmissionCount()
      this.FeeAmountCount();
      this.get('','College')
      this.getCollegeData();
      }
    );
  }

  

  college(){
    this.redirect('college-data')
  }
    
  CourseLevelQualification(){
    this.redirect('course-level-qualification')
  }

  course(){
    this.redirect('course-data')
  }
  
  exam(){
    this.redirect('exam-data')
  }
  grievance(){
    this.redirect('complaint')
  }


  redirect(to): void {
    this.router.navigate([to]);
  }

  DashBoardCount(){
    const payload = {};
    payload['SnNo'] = this.DasboardForm.value.SnNo || this.SessionNo,
    payload['CoCode'] = this.DasboardForm.value.CoCode || '',
    payload['CgCode'] = this.DasboardForm.value.CgCode || '',
  payload['FromDate'] = this.formatDateToSQL(this.DasboardForm.value.FromDate);
  payload['ToDate']   = this.formatDateToSQL(this.DasboardForm.value.ToDate);
    // payload['FromDate'] = this.DasboardForm.value.FromDate || '',
    // payload['ToDate'] = this.DasboardForm.value.ToDate || '',
    this.umsService.DashBoardCount(payload).subscribe(res => {
      if (res.status) {
        this.totalExams = res.data[0]['TotalExams'];
        this.totalCourses = res.data[0]['TotalCourses'];
        this.totalCollege = res.data[0]['TotalColleges'];
        this.totalStu = res.data[0]['studentCount'];
        this.totalApplication = res.data[0]['TotalApplications'];
        this.incompleteApplication = res.data[0]['IncompleteApplications'];
        this.underScrutiny = res.data[0]['UnderScrutiny'];
        this.approveApplication = res.data[0]['ApprovedApplications'];
        this.totalPaidApplication = res.data[0]['TotalPaidApplications'];
        this.totalUnpaidApplication = res.data[0]['TotalUnpaidApplications'];
        this.rejectedApplication = res.data[0]['RejectedApplications'];
        this.documentError = res.data[0]['DocumentsError'];
        this.setCards(); 
        this.loadKpiCards();
        // this.totalGrievance = res.data[0]['TotalGrievance'];
      }
    })
  }
  private formatDateToSQL(date: Date | string | null): string | null {
  if (!date) return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
  getDrp(data){
    if(data == 'College'){
      this.Showcollege = true;
      this.Showcourse = false;
      this.getCollegeData();
      
    }
    else if(data == 'Course'){
      this.Showcollege = false;
      this.Showcourse = true;
      this.getCourseData();
    }
  }

  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegedataList = res.data;
      this.filteredListCollege = this.collegedataList.slice();
    },(ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }

  getCourseData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courselist = res.data;
      this.filteredListCourse = this.courselist.slice();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      
    });
  }

  getTown(){
    this.spinner.show();
    const payload = {};
    this.umsService.getTown(payload).subscribe(res => {
      this.spinner.hide();
      this.townlist = res.data;
      this.filteredListTown = this.townlist.slice();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      
    });
  }

  getDistrict(){
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      this.spinner.hide();
      this.districtlist = res.data;
      this.filteredListDistrict = this.districtlist.slice();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      
    });
  }

  get(value,type){
    console.log('type',type);
    
    const payload = {};
    payload['FilterType'] = type;
    payload['FilterText'] = value;
    payload['SnNo'] = this.SessionNo
    this.barChartData3[0].data = [];
    this.barChartLabels3 = [];
    this.umsService.CourseColgCounts(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.status == true){
        res.data.forEach(element => {
          this.barChartLabels3.push(element.Title)
          this.barChartData3[0].data.push(element.TotalCount)
        });
      }
      
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  StuPerformance(value){
    if(value === 'college'){
      this.Showcollege2 = true;
      this.Showcourse2 = false;
      this.ShowTown = false;
      this.ShowDistrict = false;
      this.getCollegeData();
    }
    else if(value === 'course'){
      this.Showcollege2 = false;
      this.Showcourse2 = true;
      this.ShowTown = false;
      this.ShowDistrict = false;
      this.getCourseData();
    }
    else if(value === 'town'){
      this.Showcollege2 = false;
      this.Showcourse2 = false;
      this.ShowTown = true;
      this.ShowDistrict = false;
      this.getTown();

    }
    else if(value === 'district'){
      this.Showcollege2 = false;
      this.Showcourse2 = false;
      this.ShowTown = false;
      this.ShowDistrict = true;
      this.getDistrict();
    }
   
  }

  loadgraph(value){
    const payload = {};
    this.barChartLabels1 = [];
    this.barChartData1[0].data = []
    this.barChartData1[1].data = []
    payload['value'] = value;
    payload['SnNo'] = this.SessionNo;
    this.umsService.StuPerform(payload).subscribe((res) => {
      this.spinner.hide();
      if(value == 'college'){
        this.collegeChartData.forEach(element => {
          const isDuplicate = this.barChartLabels1.some((item: any) => item === element.Course);
            // If it's not a duplicate, push the new item
            if (!isDuplicate) {
              this.barChartLabels1.push(element.Course)
              this.barChartData1[0].data.push(element.TotalPass)
              this.barChartData1[1].data.push(element.TotalFail)
            } else {
            }
        })
        
      }
      
      else if(value == 'course' || value === 'town' || value === 'district'){
        this.courseChartData.forEach(element => {
          const isDuplicate = this.barChartLabels1.some((item: any) => item === element.College);
          // If it's not a duplicate, push the new item
          if (!isDuplicate) {
            this.barChartLabels1.push(element.College)
            this.barChartData1[0].data.push(element.TotalPass)
            this.barChartData1[1].data.push(element.TotalFail)
          } else {
          }
        })
      }
      // res.Data.forEach(element => {
        
      //   if(element.Course != undefined){
      //     const isDuplicate = this.barChartLabels1.some((item: any) => item === element.Course);
      //       // If it's not a duplicate, push the new item
      //       if (!isDuplicate) {
      //         this.barChartLabels1.push(element.Course)
      //         this.barChartData1[0].data.push(element.TotalPass)
      //         this.barChartData1[1].data.push(element.TotalFail)
      //       } else {
      //       }
      //   }
      //   else if(element.College != undefined){
         
      //   }
        
      //   // this.barChartLabels1
      //   // this.barChartData[0].data = data.registrationCount;
      // });
      
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  GenderCount(){
    this.doughnutChartData = [];
    const payload = {};
    payload['SnNo'] = this.SessionNo;
    this.umsService.GenderCount(payload).subscribe(res => {
      if (res.status) {
        // Initialize counts with 0 for both female and male
        let femaleCount = 0;
        let maleCount = 0;
  
        // Loop through the data to find counts for female and male
        res.data.forEach(item => {
          if (item.RgSex === 'F') {
            femaleCount = item.TotalGender;
          } else if (item.RgSex === 'M') {
            maleCount = item.TotalGender;
          }
        });
  
        // Push counts in the order of doughnutChartLabels
        this.doughnutChartData.push(femaleCount);
        this.doughnutChartData.push(maleCount);
      }
    });
  }

  CasteCount(){
    this.pieChartData = []
    this.pieChartLabels = []
    const payload = {};
    payload['SnNo'] = this.SessionNo
    this.umsService.CasteCount(payload).subscribe(res => {
      if (res.status) {
        // res.data.forEach(element => {
        //   if(element.StuConstiSubCate == 1){
        //     this.pieChartLabels.push('Other Backward Class')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 2){
        //     this.pieChartLabels.push('General')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 3){
        //     this.pieChartLabels.push('Schedule Caste')
        //    this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 4){
        //     this.pieChartLabels.push('Schedule Tribe')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 5){
        //     this.pieChartLabels.push('Special Backward Class')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 6){
        //     this.pieChartLabels.push('VJ/DT-A')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 7){
        //     this.pieChartLabels.push('NT-B (NT-1)')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 8){
        //     this.pieChartLabels.push('NT-C (NT-2)')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        //   else if(element.StuConstiSubCate == 9){
        //     this.pieChartLabels.push('NT-D (NT-3)')
        //     this.pieChartData.push(element.TotalCaste);
        //   }
        // });
        res.data.forEach(element => {
          if(element.StuConstiSubCate == 1){
            this.pieChartLabels.push('Other Backward Class')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'GM'){
            this.pieChartLabels.push('General')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'SC'){
            this.pieChartLabels.push('Schedule Caste')
           this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'ST'){
            this.pieChartLabels.push('Schedule Tribe')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'SBC'){
            this.pieChartLabels.push('Special Backward Class')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'VJDT'){
            this.pieChartLabels.push('VJ/DT-A')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'NT-B'){
            this.pieChartLabels.push('NT-B (NT-1)')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'NT-C'){
            this.pieChartLabels.push('NT-C (NT-2)')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'NT-D'){
            this.pieChartLabels.push('NT-D (NT-3)')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'OBC'){
            this.pieChartLabels.push('OBC')
            this.pieChartData.push(element.TotalCaste);
          }
          else if(element.StuConstiSubCate == 'MOBC'){
            this.pieChartLabels.push('MOBC')
            this.pieChartData.push(element.TotalCaste);
          }
          
        });
      }
    })
  }

  AdmissionCount(){
    this.barChartLabels = [];
    this.barChartData[0].data = []
    this.barChartData[1].data = []
    const payload = {};
    payload['SnNo'] = this.SessionNo
    this.umsService.AdmissionCount(payload).subscribe(res => {
      if (res.status) {
        res.data.forEach(element => {
          this.barChartLabels.push(element.RgCgCode);
          this.barChartData[0].data.push(element.PermittedIntake);
          this.barChartData[1].data.push(element.TotalAdmission);
        });
      }
    })
  }


  FeeAmountCount(){
    this.barChartLabels2 = [];
    this.barChartData2[0].data = []
    this.barChartData2[1].data = []
    const payload = {};
    payload['SnNo'] = this.SessionNo
    this.umsService.getFeecount(payload).subscribe(res => {
      if (res.status) {
        res.data.forEach(element => {
          this.barChartLabels2.push(element.CgCode);
          this.barChartData2[0].data.push(element.TotalPaidAmount);
          this.barChartData2[1].data.push(element.OutstandingAmount);
        });
      }
    })
  }

  StudentRequest(){
  this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    let payload = {};
    payload['SessionId'] = this.SessionNo
    this.umsService.GetTclcStudents(payload).subscribe(res => {
      if(res.status){
        if(this.userPermission[0].CgUi == 'C'){
          this.countofcolg(this.SessionNo,this.userPermission[0].CgId)
        }
        else if(this.userPermission[0].CgUi == 'U'){
          this.totalCount = res.data[0]['CountTcLc']
          this.setCards();
        }
        
      }
      
    })
    
  }

  Request(){
    this.redirect('TclcScrutiny')
  }

  countofcolg(SnNo,CgCode){
    let payload = {}
    payload['SessionId'] = SnNo
    payload['CertType'] =  'All'
    payload['StuId'] = 0
    this.umsService.GetTclcData(payload).subscribe((res) => {
     if(res.status){
        let TclcData = []
        let TclcIncoming = []
        TclcData = res.data.filter(record => record.StuCollege == CgCode);
        TclcIncoming = res.data.filter(record => record.DestClg == CgCode && record.CertType != 'ADMC' && record.FeeStatus == 'Y');
        let TotalCount = TclcData.length + TclcIncoming.length
        this.totalCount = TotalCount
        this.setCards();
    
  }
  })
  }
  GrievanceCount(){
    console.log('permission data',sessionStorage.getItem("userPermission"));
    
    if(sessionStorage.getItem("userPermission")){
      this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    }
    
      let payload = {};
      payload['SnNo'] = this.SessionNo
      this.umsService.DashBoardCount(payload).subscribe(res => {
        if(res.status){
          if(this.userPermission[0].CgUi == 'C'){
            this.getComplaintData(this.userPermission[0].CgId)
          }
          else if(this.userPermission[0].CgUi == 'U'){
            this.totalGrievance = res.data[0]['TotalGrievance'];
          this.setCards();
          }
          else{
            this.totalGrievance = res.data[0]['TotalGrievance'];
          this.setCards();
          }
         
        }
       
      })
    }

    getComplaintData(CgCode) {
      // this.spinner.show();
      const payload = {};
      payload['UserID'] = sessionStorage.getItem('userId')
      this.umsService.getComplaint(payload).subscribe(res => {
        // this.spinner.hide();
        let complaintList = []
        complaintList = res.data.filter(record => record.CgCode == CgCode  && (record.StatusCode == 'O' || record.StatusCode == 'IP'));
        let TotalGrievance = complaintList.length
        this.totalGrievance = TotalGrievance;
          this.setCards();
      });
    }

    getUserPermission() {
      this.spinner.show()
      let payload = {};
      payload['UserId'] = sessionStorage.getItem('userId');
      this.umsService.getPermission(payload).subscribe(res => {
        if(res.data){
          sessionStorage.setItem('userPermission', JSON.stringify(res.data))
          this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
          this.spinner.hide()
          this.GrievanceCount();
          this.StudentRequest()
        }
        else{
          this.spinner.hide()
        }
        
      },(ERROR:HttpErrorResponse) => {
        this.spinner.hide()
      });
    
    }
  onSessionChange(value: any){
  this.SessionNo = value;
  this.DasboardForm.get('CoCode')?.reset();
  this.DasboardForm.get('CgCode')?.reset();
  this.DasboardForm.get('FromDate')?.reset();
  this.DasboardForm.get('ToDate')?.reset();
    }

  onCourseChange(){
  this.DasboardForm.get('CgCode')?.reset();
  this.DasboardForm.get('FromDate')?.reset();
  this.DasboardForm.get('ToDate')?.reset();
    }
  onCollegeChange(){
  this.DasboardForm.get('FromDate')?.reset();
  this.DasboardForm.get('ToDate')?.reset();
    }
   fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

    validateDates() {

    const fromDate = this.DasboardForm.get('FromDate')?.value;
    const toDate = this.DasboardForm.get('ToDate')?.value;

    const fromDateControl = this.DasboardForm.get('FromDate');
    const toDateControl = this.DasboardForm.get('ToDate');

    const today = new Date();

    // From Date cannot be greater than today
    if (fromDate && new Date(fromDate) > today) {
      fromDateControl?.setErrors({ ...fromDateControl.errors, maxDate: true });
      return;
    }

    // To Date cannot be greater than today
    if (toDate && new Date(toDate) > today) {
      toDateControl?.setErrors({ ...toDateControl.errors, maxDate: true });
      return;
    }

    // To Date without From Date
    if (toDate && !fromDate) {
      toDateControl?.setErrors({ ...toDateControl.errors, fromRequired: true });
      return;
    }

    // To Date earlier than From Date
    if (fromDate && toDate) {
      if (new Date(toDate) < new Date(fromDate)) {
        toDateControl?.setErrors({ ...toDateControl.errors, invalidDate: true });
        return;
      } else {
        toDateControl?.setErrors(null);
      }
    }

    // this.fetchDashboardSummary();
  }
    fetchCourseData() {
    this.spinner.show()
    const payload = {};
    this.umsService.fetchCutOffCourse(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
   FetchCollegeData(CoCode) {
    this.collegedataList =[];
    this.filteredListCollege=[]
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    payload['CgCode'] = '';
    payload['CoStr'] = '';
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.collegedataList = Array.from(
          new Map(res.data.map((item) => [item.CgCode, item])).values()
        );
        
        this.filteredListCollege = [...this.collegedataList];
   
      }
      else{
        this.spinner.hide();
        this.collegedataList =[];
        this.filteredListCollege=[]
      }
       
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  setCards() {
  this.cards = [
    {
      title: 'TOTAL COLLEGES',
      value: this.totalCollege,
      image: '../../assets/img/college.png',
      click: () => this.college()
    },
    {
      title: 'TOTAL COURSES',
      value: this.totalCourses,
      image: '../../assets/img/online-course.png',
      click: () => this.course()
    },
    {
      title: 'TOTAL EXAMS',
      value: this.totalExams,
      image: '../../assets/img/exam.png',
      click: () => this.exam()
    },
    {
      title: 'STUDENT REQUEST',
      value: this.totalCount,
      image: '../../assets/img/ask-question.png',
      click: () => this.Request()
    },
    {
      title: 'TOTAL GRIEVANCE',
      value: this.totalGrievance,
      image: '../../assets/images/complain.png',
      click: () => this.grievance()
    },
    
  ];
}

loadKpiCards() {
  this.kpiCards = [
    {
      title: 'Total Applications',
      value: this.totalApplication,
      icon: 'description',
      color: 'blue'
    },
    {
      title: 'Incomplete Applications',
      value: this.incompleteApplication,
      icon: 'warning',
      color: 'orange'
    },
    {
      title: 'Applications Under Scrutiny',
      value: this.underScrutiny,
      icon: 'search',
      color: 'purple'
    },
    {
      title: 'Approved Applications',
      value: this.approveApplication,
      icon: 'check_circle',
      color: 'green',
      change: '+8%',
      note: 'this week'
    },
    {
      title: 'Total Paid Applications',
      value: this.totalPaidApplication,
      icon: 'payments',
      color: 'blue'
    },
    {
      title: 'Rejected Applications',
      value: this.rejectedApplication,
      icon: 'cancel',
      color: 'red',
      change: '-2%',
      note: 'this week'
    },
    {
      title: 'Total Unpaid Applications',
      value: this.totalUnpaidApplication,
      icon: 'money_off',
      color: 'gray'
    },
    {
     title: 'Document Error Applications',
     value: this.documentError,
     icon: 'error_outline',
    color: 'teal'
  },
  ];
}
}
